module.exports = __webpack_public_path__ + "img/no.4004c9d0.svg";